import { render, staticRenderFns } from "./send-mail.vue?vue&type=template&id=a3aee11a"
import script from "./send-mail.vue?vue&type=script&lang=js"
export * from "./send-mail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports